import { AttributeDefinitionResponse } from '@bluestone-node-sdk/pim';
import candidateApi from '~/clientApis/candidateApi';
import { showMessageModal } from '~/clientUtils/showMessageModal';
import { CANDIDATE_SELECT_OPTIONS_NUMBERS } from '~/consts/candidates';
import { CandidateAttributeOption } from '~/definitions/candidates';
import { getStore } from '~/mobx/AppStore';

export const getCandidateAttributeOptions = async () => {
    const candidateStore = getStore().candidateStore;

    candidateStore.setIsLoadingCandidateAttributesOptions(true);

    try {
        const attributes: AttributeDefinitionResponse[] = await candidateApi.getCandidateAttributeOptions(
            CANDIDATE_SELECT_OPTIONS_NUMBERS
        );

        const getOptions = (restrictions: AttributeDefinitionResponse['restrictions']): CandidateAttributeOption[] => {
            return (
                restrictions?.enum?.values?.map((v) => {
                    return {
                        value: v.number || '',
                        label: v.value || '',
                    };
                }) || []
            );
        };

        // Gender
        const genderAttribute = attributes.find((attr) => attr.number === 'candidate_gender');
        if (genderAttribute) {
            if (genderAttribute.restrictions) {
                const genderOptions = getOptions(genderAttribute.restrictions);
                candidateStore.setCandidateGenderOptions(genderOptions);
            }
        }
    } catch (error) {
        showMessageModal('error', 'Error fetching candidate options');
        throw error;
    } finally {
        candidateStore.setIsLoadingCandidateAttributesOptions(false);
    }
};
